const DB_NAME = "sqljs_indexed_db";
const STORE_NAME = "databases";
const DB_KEY = "sqljs_db";

// Open IndexedDB
export const openIndexedDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
};

// Save DB
export const saveDbToIndexedDB = async (uint8Array) => {
  const db = await openIndexedDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);

    store.put(uint8Array, DB_KEY);

    tx.oncomplete = () => resolve(true);
    tx.onerror = () => reject(tx.error);
  });
};

// Load DB
export const loadDbFromIndexedDB = async () => {
  const db = await openIndexedDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readonly");
    const store = tx.objectStore(STORE_NAME);

    const request = store.get(DB_KEY);

    request.onsuccess = () => resolve(request.result || null);
    request.onerror = () => reject(request.error);
  });
};

// Delete DB (optional)
export const deleteDbFromIndexedDB = async () => {
  const db = await openIndexedDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);

    store.delete(DB_KEY);

    tx.oncomplete = () => resolve(true);
    tx.onerror = () => reject(tx.error);
  });
};